<template>
    <div class="question-form">
        <d-header></d-header>
        <div style="margin: 2em;">
            <b-navbar toggleable="lg" class="bg-white-color" style="padding: 0 0 0.75em 0; border-bottom: 1px solid #2DA1A9;">
                <question-status/>
                <profile-status/>
            </b-navbar>
            <div class="my-md-4" style="text-align: center">
                <span class="font22 font-title-color">บันทึกรายละเอียดแห่งการชันสูตรพลิกศพ</span>
            </div>
            <form1></form1>
            <div class="mt-lg-4 mt-sm-2 mt-md-2" style="text-align: center">
                <b-button class="autopsy-button" @click="goToHomePage()">บันทึก</b-button>
            </div>
        </div>
        <d-footer></d-footer>
    </div>
</template>

<script>
    import DHeader from "../components/Header";
    import DFooter from "../components/Footer";
    import Form1 from "../components/form/form1";
    import Form2 from "../components/form/form2";
    import Form3 from "../components/form/form3";
    import ProfileStatus from "../components/ProfileStatus";
    import QuestionStatus from "../components/QuestionStatus";

    export default {
        name: "question-form",
        components: {
            QuestionStatus,
            ProfileStatus,
            Form1,
            Form2,
            Form3,
            DHeader,
            DFooter,
            ProfileStatus
        },
        created() {
            window.scrollTo(0,0);
        },
        methods:{
            goToHomePage() {
                const path = `/home`
                if (this.$route.path !== path) this.$router.push(path)
            },
        }
    }
</script>

<style scoped>

</style>
